const API_BASE_URL_V1 = '/api/v1'

export const ENDPOINTS = {
    PRODUCT_LISTING: `${API_BASE_URL_V1}/product-listing`,
    BRANCHES: `${API_BASE_URL_V1}/branches`,
    PANEL_LOCATOR: `${API_BASE_URL_V1}/panel-locator`,
    HIGHLIGHTS_LISTINGS_SEARCH: `${API_BASE_URL_V1}/highlight-listing`,
    DOWNLOADS: `${API_BASE_URL_V1}/downloads`,
    FAQ_SEARCH: `${API_BASE_URL_V1}/faq`,
    PRODUCT_COMPARISON: `${API_BASE_URL_V1}/product-comparison`,
    JOB_LISTING_SEARCH: `${API_BASE_URL_V1}/job-listing/search`,
    GLOBAL_SEARCH: `${API_BASE_URL_V1}/page/search`,
}
